

export class Admin {
  firstName: string;
  lastName: string;
  userId: string;
  builderId: string;
  email: string;
}
